module.exports = __webpack_public_path__ + "static/media/long-logo.2e662b57.png";